import { render, staticRenderFns } from "./featuresItem.vue?vue&type=template&id=1b0dd5a7&scoped=true"
import script from "./featuresItem.vue?vue&type=script&lang=js"
export * from "./featuresItem.vue?vue&type=script&lang=js"
import style0 from "./featuresItem.vue?vue&type=style&index=0&id=1b0dd5a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0dd5a7",
  null
  
)

export default component.exports